import {RestService} from './_rest.service'
import {REST_API_END_POINTS} from './constants'
import {PenaltyAmount} from "../api";

export class PenaltyService extends RestService<PenaltyAmount> {
    constructor(url: string) {
        if (!url) {
            super(REST_API_END_POINTS.PENALTY)
        } else {
            super(url)
        }
    }
}
